<script setup>
import { defineProps } from 'vue';

defineProps(['text']);
</script>

<template>
  <span class="help-message">{{ text }}</span>
</template>

<style scoped lang="scss">
.help-message {
  display: block;
  font-size: 1.2rem;
  color: #6b7280;
  margin-bottom: 4px;
  line-height: 1.4;
}
</style>